export const frontEnd = [
    {
        name: 'React',
        icon: 'react.png',
    },
    {
        name: 'Angular',
        icon: 'angular.png',
    },
    {
        name: 'React Native',
        icon: 'react.png',
    },
    {
        name: 'Redux Toolkit',
        icon: 'redux.svg',
    },
    {
        name: 'HTML5',
        icon: 'html.png',
    },
    {
        name: 'CSS3',
        icon: 'CSS3.svg',
    },
    {
        name: 'Sass',
        icon: 'sass.png',
    },
    {
        name: 'JavaScript',
        icon: 'js.png',
    },
    {
        name: 'TypeScript',
        icon: 'ts.png',
    },
    {
        name: 'Flutter (with Dart)',
        icon: 'flutter.svg',
    },
];

export const backEnd = [
    {
        name: 'Python',
        icon: 'python.png'
    },
    {
        name: 'Electron',
        icon: 'electron.png',
    },
    {
        name: 'Node',
        icon: 'node.png',
    },
    {
        name: 'GraphQL',
        icon: 'graphql.png'
    },
    {
        name: 'MySQL',
        icon: 'mysql.svg'
    },
    {
        name: 'MongoDB',
        icon: 'mongo.svg'
    },
    {
        name: 'RESTful APIs',
        icon: 'api.svg'
    },
    {
        name: 'JSON',
        icon: 'json.png'
    },
    {
        name: 'Websockets',
        icon: 'connect.svg'
    },
];

export const ideTools = [
    {
        name: 'Visual Studio Code',
        icon: 'vscode.png'
    },
    {
        name: 'Android Studio',
        icon: 'android-studio.png'
    },
    {
        name: 'PyCharm',
        icon: 'pycharm.png',
    },  
    {
        name: 'Atom',
        icon: 'atom.png',
    },
    {
        name: 'Chrome developer tools',
        icon: 'chrome.png',
    },
    {
        name: 'React developer tools',
        icon: 'react.png',
    },
    {
        name: 'Redux developer tools',
        icon: 'redux.svg',
    },
    {
        name: 'Postman',
        icon: 'postman.svg',
    },
    
];

export const designTools = [
    {
        name: 'Figma',
        icon: 'figma.png'
    },
    {
        name: 'Canva',
        icon: 'canva.png'
    },
];


export const versionControl = [
    {
        name: 'GitLab',
        icon: 'gitlab.webp'
    },
    {
        name: 'GitHub',
        icon: 'github.png'
    }
];

export const planning = [
    {
        name: 'Project breakdown',
        icon: 'breakdown.svg'
    },
    {
        name: 'Task estimation',
        icon: 'estimation.svg'
    },
    {
        name: 'Resource allocation',
        icon: 'resource.svg'
    },
    {
        name: 'Risk Management',
        icon: 'risk.svg'
    },
    {
        name: 'Agile methodologies',
        icon: 'collab.svg'
    }
];

export const optimization = [
    {
        name: 'Code splitting',
        icon: 'codesplit.svg'
    },
    {
        name: 'Lazy loading',
        icon: 'lazyload.svg'
    },
    {
        name: 'Caching techniques',
        icon: 'cache.svg'
    },
];

export const problemSolving = [
    {
        name: 'Attention to detail',
        icon: 'troubleshoot.svg'
    },
    {
        name: 'Pixel-perfect builds',
        icon: 'star.svg'
    }, 
    {
        name: 'Acute pattern recognition',
        icon: 'specs.svg'
    },
    {
        name: 'Strong problem-solving skills',
        icon: 'problem.svg'
    },
    {
        name: 'Excellent communication and interpersonal skills',
        icon: 'comms.svg'
    },
    {
        name: 'Cross-functional team collaboration',
        icon: 'team.svg'
    },
];

export const statusDetails = [
    {
        key: 1,
        item: 'Nationality',
        value: 'India'
    },
    {
        key: 2,
        item: 'Date of Birth',
        value: '24 April 1987'
    },
    {
        key: 3,
        item: 'Visa Status',
        value: 'UK work rights until April 2026'
    },
    {
        key: 4,
        item: 'Marital Status',
        value: 'Married'
    },
    {
        key: 5,
        item: 'Driving Licenses',
        value: 'Great Britain, UAE, India'
    },
];

export const languageDetails = [
    {
        key: 1,
        item: 'English (Bilingual)',
        value: '🌕🌕🌕🌕🌖'
    },
    {
        key: 2,
        item: 'Malayalam (Native)',
        value: '🌕🌕🌕🌕🌖'
    },
    {
        key: 3,
        item: 'Hindi (Fluent)',
        value: '🌕🌕🌕🌕🌗'
    },
    {
        key: 4,
        item: 'Urdu (Fluent)',
        value: '🌕🌕🌕🌕🌗'
    },
    {
        key: 5,
        item: 'Arabic (Limited)',
        value: '🌕🌕🌗🌑🌑'
    },
    {
        key: 6,
        item: 'French (Elementary)',
        value: '🌕🌑🌑🌑🌑'
    },
];

export const contactDetails = [
    {
        key: 1,
        item: 'Phone',
        icon: '',
        value: '0044 7879887539',
    },
    {
        key: 2,
        item: 'LinkedIn',
        icon: '',
        value: '/in/manalabdulgafoor/',
        link: 'https://www.linkedin.com/in/manalabdulgafoor/'
    },
    {
        key: 3,
        item: 'E-mail',
        icon: '',
        value: 'manalgafoor24@gmail.com'
    },
    {
        key: 4,
        item: 'Location',
        icon: '',
        value: 'London, UK'
    },
    {
        key: 5,
        item: 'Github',
        icon: '',
        value: 'GitHub',
        link: 'https://github.com/manal-gafoor'
    },
    // {
    //     key: 6,
    //     item: 'Website',
    //     icon: '',
    //     value: 'Website',
    //     link: 'https://manal-gafoor.github.io/cv/'
    // },
];